module.exports = __webpack_public_path__ + "img/banner1.993805a2.png";